// src/utils/utils.ts
export function downloadCSV(missingProducts: { [id: string]: string }) {
  const csvRows: string[] = [];

  // Přidání hlavičky CSV
  csvRows.push("ID,Název");

  // Přidání dat s ohraničením hodnot v uvozovkách
  for (const [id, title] of Object.entries(missingProducts)) {
    // Uložit hodnoty do uvozovek, aby se předešlo problémům s čárkami
    csvRows.push(`"${id}","${title.replace(/"/g, '""').trim()}"`);
  }

  // Sestavení CSV obsahu
  const csvContent = csvRows.join("\n");

  // Vytvoření Blob místo použití data URI
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

  // Vytvoření odkazu pro stažení Blobu
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", "missing_products.csv");

  // Připojit a kliknout na odkaz pro stažení
  document.body.appendChild(link);
  link.click();

  // Uvolnění URL a odstranění odkazu
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

// Přidejte implementaci compareFeeds
export function compareFeeds(
  oldProducts: { [id: string]: string },
  newProducts: { [id: string]: string }
) {
  const missingProducts: { [id: string]: string } = {};
  for (const [id, title] of Object.entries(oldProducts)) {
    if (!newProducts[id]) {
      missingProducts[id] = title;
    }
  }
  return missingProducts;
}
